import type { PropsWithChildren } from 'react';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import type { RoutesContextType } from './RoutesContext.ts';
import { RoutesContext } from './RoutesContext.ts';

type QueryRendererProps = PropsWithChildren<{
	queryMatcher(queryParams: ReturnType<RoutesContextType['getQueryParams']>): boolean;
}>;

export class QueryRenderer extends Component<QueryRendererProps> {
	static propTypes = {
		queryMatcher: PropTypes.func.isRequired,
		children: PropTypes.node,
	};

	render() {
		const { children, queryMatcher } = this.props;
		return (
			<RoutesContext.Consumer>
				{({ getQueryParams }) =>
					children && queryMatcher(getQueryParams()) ? <Fragment>{children}</Fragment> : null
				}
			</RoutesContext.Consumer>
		);
	}
}
